import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  LoginFormInterface,
  LoginState,
  ResponseLoginInterface,
  FormDataErrorInterface,
} from "../../domain";

const initialState: LoginState = {
  formData: {
    email: "",
    password: "",
  },
  formDataError: {
    email: false,
    password: false,
  },
  loading: false,
  error: {
    message: "",
    status: false,
  },
  success: false,
  responseLogin: {
    displayName: "",
    email: "",
    expiresIn: 0,
    idToken: "",
    kind: "",
    localId: "",
    refreshToken: "",
    registered: false,
    success: false,
  },
};

const LoginSlice = createSlice({
  name: "login",
  initialState,
  reducers: {
    setFormDataReducer: (
      state,
      action: PayloadAction<Partial<LoginFormInterface>>
    ) => {
      state.formData = { ...state.formData, ...action.payload };
    },
    setFormDataErrorReducer: (
      state,
      action: PayloadAction<Partial<FormDataErrorInterface>>
    ) => {
      state.formDataError = { ...state.formDataError, ...action.payload };
    },
    submitLoginStartReducer: (state) => {
      state.loading = true;
      state.error = {status: false, message: ""};
      state.success = false;
    },
    submitLoginSuccessReducer: (
      state,
      action: PayloadAction<ResponseLoginInterface>
    ) => {
      state.loading = false;
      state.success = true;
      state.error = {status: false, message: ""};
      state.formData = initialState.formData;
      state.responseLogin = action.payload;
    },
    submitLoginFailureReducer: (state, action: PayloadAction<string>) => {
      state.loading = false;
      state.error = {status: true, message: action.payload};
      state.success = false;
    },
    clearLoginErrorReducer: (state) => {
      state.error = {status: false, message: ""};
      state.success = false;
    },
    resetLoginStateReducer: (state) => {
      state.formData = initialState.formData;
    },
    setLoadingReducer: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    }
  },
});

export const {
  setFormDataReducer,
  submitLoginStartReducer,
  submitLoginSuccessReducer,
  submitLoginFailureReducer,
  clearLoginErrorReducer,
  resetLoginStateReducer,
  setFormDataErrorReducer,
  setLoadingReducer
} = LoginSlice.actions;

export default LoginSlice.reducer;
